import Head from 'next/head';
import { useState, useEffect } from "react";
import Template from "@/widgets/index";
import styles from "./styles.module.css";
import Footer from "@/shared/components/Footer";
import Header from "@/shared/components/Header";
import { useAppContext } from '@pagegrowler_nextjs';
import ContenedorTitulo from '@/shared/components/ContenedorTitulo';
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import BannerHorizontalGrande from '@/widgets/Banner/Templates/BannerHorizontalGrande';
import Chartbeat from '@/shared/components/Chartbeat';

function Autores(props) {

  // estado booleano, para determinar si la data que se le envia a NotaDeSeccion, viene del servidor o del cliente
	const [conditionDataRender, setConditionDataRender] = useState(false);

  const LOAD_MORE = 12;

  const { 
    content,		
    pagination = {} 
  } = { ...props };

  const description = `Autores de Noticias del diario El Litoral- Noticias actualizadas las 24hs.`

  let [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  let [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hideLoadMore, setHideLoadMore] = useState(false);

	const pg = useAppContext();
	const Pagegrowler = pg.pagegrowler;

  let menues = props.menu ? props.menu : [];

  async function showMoreData() {
    setConditionDataRender(true)
		setIsLoading(true);
		let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
		if (res.content && res.content.length > 0){
      setData(prevState => [...prevState, ...res.content]);
		  setOffset(offset + LOAD_MORE);
		  setIsLoading(false);
    } else {
      setHideLoadMore(true);
    }
	}

  let dataLDJson =  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Diario El Litoral",
    "url": "https://www.ellitoral.com",
    "logo": {
      "@type": "ImageObject",
      "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
      "width": 439,
      "height": 60
    },
    "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
  };
  useEffect(() => {
		setOffset(pagination.limit + pagination.offset);
		setData(content);
	}, []);

  return (
    <>
      <Head>
        <title>Autores - El Litoral</title>
        <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <meta name="description" content={description} />
        <meta name="og:description" property="og:description" content={description} />
        <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />
        <meta httpEquiv="refresh" content="600" />
        <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + "/autores"} />
      </Head>
      <Chartbeat />
      <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
      <div className={`${styles["parent"]}`}>
        <div className={styles["container"]}>
          {!props.preview && <BannerHorizontalChico bannerId={'top'}/>}
          <ContenedorTitulo text={'Autores'}/>
          <Template.Autores authors={conditionDataRender ? data : content} />
          <div className={styles["button-container"]}>
            <button className={`${styles["button"]} ${styles[hideLoadMore? 'hide': '']}`} disabled={isLoading} onClick={showMoreData}>
              Cargar más autores
            </button>
          </div>
        </div>
        {!props.preview && <BannerHorizontalChico bannerId={'horizontal1'}/>}
      </div>
      <div style={{ clear: "both" }}>
        <Footer />
      </div>
    </>
  );
}

export default Autores;
